import { render, staticRenderFns } from "./FavoriteEmail.vue?vue&type=template&id=5c6dbbb2&scoped=true&"
import script from "./FavoriteEmail.vue?vue&type=script&lang=js&"
export * from "./FavoriteEmail.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteEmail.vue?vue&type=style&index=0&id=5c6dbbb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6dbbb2",
  null
  
)

export default component.exports